export default {
	name: "select-customer-order-modal",
	props: ["heading", "modalId", "showModal", "company"],
	emits: ["closeClicked"],
	data() {
		return {
			modalHeading: null,
			modalComponentId: null,
			selectedCompany: {}
		};
	},
	methods: {
		navigateToDeliveryOrders(){
			this.$router.push("/orders/delivery/" + this.selectedCompany.companyId);
			this.$emit("closeClicked", true);
		},
		navigateToCollectionOrders() {
			this.$router.push("/orders/collection/" + this.selectedCompany.companyId);
			this.$emit("closeClicked", true);
		},
		navigateToExTankOrders(){
			this.$router.push("/orders/extank/" + this.selectedCompany.companyId);
			this.$emit("closeClicked", true);
		},
		onModalCloseClick(){
			this.$emit("closeClicked", true);
		}
	},
	mounted: function () {
		
	},
	watch: {
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal("show");
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		},
		company: {
			handler: function () {
				if (this.company !== null) {
					this.selectedCompany = JSON.parse(JSON.stringify(this.company));
					this.selectedCompany.enableCollectionOrders = castingUtility.toBoolean(this.selectedCompany.enableCollectionOrders);
					this.selectedCompany.enableDeliveryOrders = castingUtility.toBoolean(this.selectedCompany.enableDeliveryOrders);
					this.selectedCompany.enableExTankOrders = castingUtility.toBoolean(this.selectedCompany.enableExTankOrders);
				}
			},
			immediate: true,
			deep: true
		}
	}
};